import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from 'store/redux/baseQuery';

const ninjaApi = createApi({
  baseQuery: baseQuery,
  endpoints: (build) => ({
    fake: build.query({
      query: '/',
    }),
  }),
  reducerPath: 'api',
  tagTypes: [
    'User',
    'DefaultWorkspace',
    'Workspaces',
    'NetworkAccount',
    'CromFormIntegrations',
    'WorkspaceBilling',
    'Postbacks',
    'Reporting',
    'Dashboard',
    'Notifications',
    'Sales',
    'Form',
    'Rules',
    'Modules',
    'Permisssions',
    'Urls',
    'Websites',
    'Country',
    'InnerReporting',
    'InnerUrl',
    'AdCampaign',
    'AdCampaign',
    'AdAdset',
    'KeywordReporting',
    'AdAd',
    'FacebookPage',
    'AppsumoCode',
    'AppsumoBillingPlan',
    'AppsumoCode',
    'SaaszillaCode',
    'SaaszillaBillingPlan',
    'SaaszillaCode',
    'Contacts',
    'Deals',
    'Shopify',
    'Woocommerce',
    'NetworkAccount',
    'Integrations',
    'CampaignSpent',
    'AI',
  ],
});

export default ninjaApi;
